import { mapRboConfigFields } from '@openx/components-deal/lib/utils/mapRboConfig';
import type { DealApi, DealOaApi } from '@openx/types/deal';
import type { PackageWithTargeting } from '@openx/types/package';
import { Intersect } from '@openx/types/targeting/targetingValuesTypes';
import type { GetDealQuery } from '../../../graphql/query/deals/GetDeal.generated';

type DealQuery = GetDealQuery['dealById'] | null | undefined;
export const formatDeal = <T = DealOaApi>(dealRes: DealQuery): T | undefined => {
  if (!dealRes) {
    return undefined;
  }

  const deal: DealApi = dealRes.exchange_deal;
  const normalizedDealId = deal?.deal_id ?? undefined;

  const rawPackage =
    (dealRes.exchange_package as Partial<PackageWithTargeting> as PackageWithTargeting | undefined) ??
    (dealRes._package?.obj as Partial<PackageWithTargeting> as PackageWithTargeting | undefined);

  const audience_id = dealRes._package?.audience_id;
  let package_obj = rawPackage;
  if (rawPackage && audience_id) {
    package_obj = structuredClone(rawPackage);
    package_obj.targeting.audience = {
      openaudience_custom: {
        op: Intersect.INTERSECTS,
        val: `openaudience-${audience_id}`,
      },
    };
  }

  return {
    ...deal,
    deal_id: normalizedDealId,
    audience: dealRes._package?.audience,
    audience_id,
    deleted: dealRes.is_archived ? 1 : 0,
    exchange_uid: dealRes.exchange_uid,
    is_direct_deal: dealRes.is_direct_deal ?? undefined,
    publisher_name: dealRes.publisher_name,
    rbo_config: mapRboConfigFields(deal?.rbo_config),
    status: dealRes.status,
    package_obj,
  } as T;
};
